import React from 'react';
import { Tooltip } from '@mui/material'; 
import { IoIosSwitch } from 'react-icons/io';

const TableHeadings = ({ columnState, setColumnState }) => {
  
  const handleToggle = (key) => {
    setColumnState(prev => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  return (
    <div>
      <Tooltip disableInteractive title="Table Headings" placement='top' arrow>
        <div className="dropdown">
          <button
            className="btn btn-light btn-active-primary pb-2 dropdown-toggle jobMonitor-Buttons"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <IoIosSwitch className='jobMonitor-svg' />
          </button>

          <ul
            className="dropdown-menu hide-scroll-bar"
            style={{ maxHeight: '500px', overflowX: 'scroll' }}
            onClick={(e) => e.stopPropagation()}
          >
            {Object.entries(columnState).map(([key, value]) => (
              <li key={key}>
                {key !== 's_no' && (
                <div className='dropdown-item'>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id={key}
                      checked={value}
                      onChange={() => handleToggle(key)}
                    />
                    <label className="form-check-label" htmlFor={key}>
                      
                      {key.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}
                    </label>
                  </div>
                </div>
                )}
              </li>
            ))}
          </ul>
        </div>
      </Tooltip>
    </div>
  );
};

export default TableHeadings;
